import { render, staticRenderFns } from "./SellRequestsList.vue?vue&type=template&id=626a1dd0&"
import script from "./SellRequestsList.vue?vue&type=script&lang=js&"
export * from "./SellRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports